import React from "react";
import { Button } from "antd";

const getStatusProps = (status) => {
  // console.log(status);
  return status
    ? {
        text: "Disable",
        color: "var(--ion-color-red-500)",
        background: "none",
        // background: "var(--ion-color-red-100)",
      }
    : {
        text: "Active",
        color: "var(--ion-color-green-600)",
        background: "none",
        // background: "var(--ion-color-green-100)",
      };
};

const Status = ({ status }) => {
  const { text, color, background } = getStatusProps(status);

  return (
    <Button
      type="text"
      style={{
        fontSize: "1rem",
        color: color,
        background: background,
      }}
    >
      {text}
    </Button>
  );
};

export default Status;
